import ReportingHeader from '../components/reportingHeader/ReportingHeader';
import {observer} from 'mobx-react';
import useReportingModel from '../common/hooks/useReportingModel';
import ReportingList from '../components/reportingList/ReportingList';
import ReportingEmpty from '../components/reportingEmpty/ReportingEmpty';
import ReportingHistory from "../components/reportingHistory/ReportingHistory";
import {useEffect, useState} from "react";
import {Attention, Button, PageContainer, Surface, Switch} from '@vidazoo/ui-kit';
import theme from './theme.module.scss';
import {useParams} from "react-router-dom";
import ReportingLoader from "../components/reportingLoader/ReportingLoader";

function Reporting() {
    const model = useReportingModel();
    const [isHeaderOpen, setHeaderOpen] = useState(true);
    const {id} = useParams<{ id: string; }>();

    useEffect(() => {
        model.setInitialParamsFromQuery(location.search, id);
    }, []);

    return (
        <PageContainer pageTitle="Reporting" top={1.2} className={theme.reporting}>
            <Surface className={theme.alert} level={0}>
                <Attention green={model.useHistoryReports} red={!model.useHistoryReports}
                    label={model.useHistoryReports ? 'You are using History Reports 🤘' : 'You are using reporting without History Reports 😭'}/>
                <Switch className={theme.historySwitch} green label="Use reporting with history reports" checked={model.useHistoryReports}
                    onChange={model.toggleUseHistoryReports}/>
            </Surface>
            <div hidden={!isHeaderOpen}>
                <ReportingHeader onFullScreen={() => setHeaderOpen(false)}/>
            </div>
            {!isHeaderOpen && <Surface className={theme.restoreHeader} level={1}>
                <Button type="button" gray medium iconName="icon-contract-small" onClick={() => setHeaderOpen(true)}>Show report controls</Button>
            </Surface>}
            {model.isLoading ? <ReportingLoader/> : null}
            {!model.isLoading && model.data.length > 0 ? <ReportingList/> : null}
            {!model.isLoading && model.data.length == 0 ? <ReportingHistory/> : null}
            <ReportingEmpty/>
        </PageContainer>
    );
}

export default observer(Reporting);
